module.exports = __webpack_public_path__ + "img/logo-liverpool (1).png";